import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { "mute-secondary": "" }
const _hoisted_3 = { "mute-secondary": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_calendar = _resolveComponent("calendar")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_space, {
      alignment: "flex-start",
      direction: "vertical",
      size: 8
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_space, {
            size: 10,
            wrap: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tag, {
                "tag-default": "",
                "is-all-borderless": "",
                round: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.opportunity.compensation.join(", "))), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_tag, {
                "tag-default": "",
                "is-all-borderless": "",
                round: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.opportunity.wow)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_space, {
            size: 8,
            wrap: ""
          }, {
            default: _withCtx(() => [
              (
              (_ctx.opportunity.wow == 'hybrid' || _ctx.opportunity.wow == 'physical') &&
              _ctx.opportunity.location !== undefined
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", {
                      primary: "",
                      class: "el-icon-location",
                      style: {"margin-right":"2px"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.opportunity.location.description), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_space, { size: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, {
                primary: "",
                style: {"margin-right":"2px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_calendar)
                ]),
                _: 1
              }),
              _createElementVNode("span", null, [
                _cache[1] || (_cache[1] = _createTextVNode(" From ", -1)),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$moment(_ctx.opportunity.startDate).format("D MMM yy")), 1)
              ]),
              _createElementVNode("span", null, [
                _cache[2] || (_cache[2] = _createTextVNode(" To ", -1)),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$moment(_ctx.opportunity.endDate).format("D MMM yy")), 1)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}